module.exports = "//static.hsappstatic.net/salesImages/static-1.403/sales-styleguide/search.png"